(() => {
  const update = () => document.documentElement.classList.toggle('nm-header-scrolled', window.scrollY > 120);
  window.addEventListener('scroll', update, {passive: true});
  window.addEventListener('pageshow', update);
  update();
  const trigger = document.querySelector('.nav-toggle');
  if (!trigger || document.querySelector('.nm-menu-bookmark')) return;
  const bookmark = document.createElement('button');
  bookmark.type = 'button';
  bookmark.className = 'nm-menu-bookmark';
  bookmark.setAttribute('aria-label', document.documentElement.lang.startsWith('en') ? 'Open menu' : 'Menü öffnen');
  bookmark.setAttribute('aria-expanded', 'false');
  bookmark.innerHTML = '<span aria-hidden="true">☰</span><span>' + (document.documentElement.lang.startsWith('en') ? 'Menu' : 'Menü') + '</span>';
  const english = document.documentElement.lang.startsWith('en');
  const shell = document.createElement('div');
  shell.className = 'nm-bookmark-shell';
  const dismiss = document.createElement('button');
  dismiss.type = 'button';
  dismiss.className = 'nm-bookmark-dismiss';
  dismiss.textContent = '×';
  dismiss.setAttribute('aria-label', english ? 'Collapse menu tab' : 'Menü-Lasche einklappen');
  const restore = document.createElement('button');
  restore.type = 'button';
  restore.className = 'nm-bookmark-restore';
  restore.textContent = '›';
  restore.setAttribute('aria-label', english ? 'Show menu tab' : 'Menü-Lasche anzeigen');
  let collapsed = false;
  try { collapsed = sessionStorage.getItem('nm_menu_tab_collapsed') === '1'; } catch (_) {}
  const setCollapsed = (value, focus = false) => {
    collapsed = value;
    bookmark.hidden = value;
    dismiss.hidden = value;
    restore.hidden = !value;
    try { sessionStorage.setItem('nm_menu_tab_collapsed', value ? '1' : '0'); } catch (_) {}
    if (focus) (value ? restore : bookmark).focus({preventScroll:true});
  };
  dismiss.addEventListener('click', () => setCollapsed(true, true));
  restore.addEventListener('click', () => setCollapsed(false, true));
  let openedFromBookmark = false;
  bookmark.addEventListener('click', () => { openedFromBookmark = true; trigger.click(); });
  shell.append(dismiss, bookmark, restore);
  document.body.appendChild(shell);
  setCollapsed(collapsed);
  const sync = () => {
    const open = document.documentElement.classList.contains('nav-open');
    bookmark.setAttribute('aria-expanded', String(open));
    shell.hidden = open;
    if (!open && openedFromBookmark) { bookmark.focus({preventScroll:true}); openedFromBookmark = false; }
  };
  new MutationObserver(sync).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
})();
